// extracted by mini-css-extract-plugin
module.exports = {"dp-business-commodity--rich":"dp-business-commodity--rich___3Uime","dp-business-commodity--rich-title":"dp-business-commodity--rich-title___U0PH6"};